import Vue from 'vue'
import moment from 'moment'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 *  Changes an advance's status (approved or rejected)
 *
 * @param  payload
 * @return {Array} Advance's info
 */

const changeAdvanceStatusReport = ({id, statusCodename, settlementDate}) => {
  let settlementDateFormat = null
  if (settlementDate) {
   settlementDateFormat = moment(settlementDate).format('YYYY-MM-DD')
    const now = moment().format('hh:mm:ss');
    settlementDateFormat = `${settlementDateFormat}T${now}`
  }
const payload = { 'advance_type': statusCodename, 'settlement_date': settlementDateFormat }  
 return Vue.$http.put(`purchase/advance_status/${id}/`, payload)
    .catch((err) => {
      throw err
    })
}

export default changeAdvanceStatusReport


// WEBPACK FOOTER //
// ./src/services/purchase/advance/changeAdvanceStatusReport.js